import { Box, Typography } from "@mui/material";
import { Download as DownloadIcon } from "@mui/icons-material";
import { getFilePreviewIcon } from "../../../helpers/extensionFile";
import { useContactCenterTheme } from "../../../../virtual-receptionist/theming/ContactCenterThemeContext";

export const MessageFile = ({ message }) => {
  const { theme } = useContactCenterTheme();
  const surface = theme.mode === "dark" ? "rgba(255,255,255,0.08)" : "rgba(255,255,255,0.6)";
  const fileUrl = message?.content?.file;
  const fileName = message?.content?.name || "Unknown File";
  const fileSize = message?.content?.mb
    ? `${message.content.mb.toFixed(2)} MB`
    : message?.content?.kb
    ? `${message.content.kb.toFixed(2)} KB`
    : "";
  const previewIcon = getFilePreviewIcon(fileName);

  const handleDownload = () => {
    if (fileUrl) window.open(fileUrl, "_blank");
  };

  return (
    <Box
      onClick={handleDownload}
      sx={{
        width: "100%",
        maxWidth: 320,
        p: 1.25,
        display: "flex",
        alignItems: "center",
        gap: 1.25,
        borderRadius: 2,
        cursor: fileUrl ? "pointer" : "default",
        transition: "all 0.25s ease",
        backgroundColor: surface,
        border: "1px solid rgba(var(--fx-surface-textrgb, 15, 23, 42), 0.12)",
        boxShadow: "none",

      }}
    >
      <Box
        component="img"
        src={previewIcon}
        alt="file preview"
        sx={{
          width: 44,
          height: 44,
          objectFit: "contain",
          backgroundColor: "rgba(var(--fx-surface-basergb, 255, 255, 255), 0.9)",
          p: 0.75,
          flexShrink: 0,
        }}
      />

      <Box
        sx={{
          flex: 1,
          minWidth: 0,
          display: "flex",
          flexDirection: "column",
          gap: 0.25,
        }}
      >
        <Typography
          variant="body2"
          sx={{
            fontSize: "0.875rem",
            fontWeight: 600,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            color: "inherit",
          }}
        >
          {fileName}
        </Typography>

        {fileSize && (
          <Typography
            variant="caption"
            sx={{
              fontSize: "0.7rem",
              color: "inherit",
              opacity: 0.7,
            }}
          >
            {fileSize}
          </Typography>
        )}
      </Box>

      <DownloadIcon
        sx={{
          fontSize: 20,
          color: theme.shell.accent,
          flexShrink: 0,
          opacity: 0.9,
        }}
      />
    </Box>
  );
};
